<div class="wrapper">
  <i class="fa fa-globe"></i>
  <div class="idiom-text">
    <select
      class="form-control"
      #selectedLang
      (change)="switchLang(selectedLang.value)"
    >
      <option
        *ngFor="let language of translate.getLangs()"
        [value]="language"
        [selected]="language === this.currentLanguage"
      >
        {{ language == "es" ? "Español" : "English" }}

      </option>
    </select>
  </div>
</div>
